/**
 * Поле поиска: лупа, ввод и «✕» для очистки (рисунок — поиск сотрудников на /people).
 * Используется в списке процессов и в «Новом процессе».
 */
import { Input, XStack } from 'tamagui'

import { useApp } from '../i18n'
import { Icon } from './Icon'
import { IconButton } from './primitives'

export function SearchField({
  value,
  onChange,
  placeholder,
  label,
  height = 40,
}: {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  /** Доступное имя поля (aria-label). */
  label: string
  height?: number
}) {
  const { l } = useApp()
  return (
    <XStack
      flex={1}
      alignItems="center"
      gap={8}
      height={height}
      paddingLeft={11}
      paddingRight={4}
      borderWidth={1}
      borderColor="$borderColor"
      borderRadius={7}
      backgroundColor="$background"
      // Фокус показывает рамка обёртки; браузерный outline самого <input> погашен ниже — иначе два кольца.
      focusWithinStyle={{ borderColor: '$primary' }}
    >
      <Icon name="search" size={15} color="$tertiary" />
      <Input
        unstyled
        flex={1}
        minWidth={0}
        height={height - 2}
        fontSize={14}
        color="$color"
        borderWidth={0}
        outlineStyle="none"
        backgroundColor="transparent"
        placeholder={placeholder}
        placeholderTextColor="$tertiary"
        aria-label={label}
        value={value}
        onChangeText={onChange}
      />
      {value ? (
        <IconButton aria-label={l('proc.clearSearch')} onPress={() => onChange('')}>
          <Icon name="x" size={15} color="$muted" />
        </IconButton>
      ) : null}
    </XStack>
  )
}
